import React, { FC, useMemo } from "react"

import { Trans } from "@lingui/macro"
import { ScrollToTopButton } from "./ScrollToTopButton"
import Logo30Years from "./30-years-logo.svg"

import styles from "./SubFooter.module.scss"

interface SubFooter {
    links: { href: string; title: string }[]
}

const SubFooter: FC<React.PropsWithChildren<SubFooter>> = ({ links }) => {
    const year = useMemo(() => new Date().getFullYear(), [])

    return (
        <div>
            <div className={styles.subFooterContainer}>
                <div className={styles.copyright}>
                    <div className={styles.logo}>
                        <Logo30Years />
                    </div>
                    &copy; {year} SILVERSEA CRUISES LTD.
                </div>
                <div className={styles.subFooterNav}>
                    <ul>
                        {links.map((l) => (
                            <li key={l.href}>
                                <a href={l.href}>{l.title}</a>
                            </li>
                        ))}
                        <li>
                            <button id="ot-sdk-btn" className={`${styles.onetrustButton} ot-sdk-show-settings`}>
                                <Trans>Cookies Settings</Trans>
                            </button>
                        </li>
                    </ul>
                </div>

                <ScrollToTopButton />
            </div>
        </div>
    )
}

export default React.memo(SubFooter)
